import Dexie from 'dexie';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var db = new Dexie('Uspacy');
db.version(0.5).stores({
    tokens: '', // Add indexedDB empty store
});
